import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { LOCALES, getInitialLocale } from './locale';
import en from './messages/en.json';
import th from './messages/th.json';

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, th: { translation: th } },
  lng: getInitialLocale(),
  fallbackLng: 'en',
  supportedLngs: [...LOCALES],
  keySeparator: false,
  nsSeparator: false,
  interpolation: { escapeValue: false },
  returnNull: false,
});

// The page is labelled in the language it is shown in, so a browser stops offering to translate
// Thai it believes is English (translation also breaks React; see lib/translated-dom-guard.ts).
document.documentElement.lang = i18n.language;
i18n.on('languageChanged', lng => {
  document.documentElement.lang = lng;
});

export { i18n };
export default i18n;
